import { isBetween, isFloat, isNumeric, random, range, serial } from "../number.ts";
Number.isFloat = isFloat;
Number.isNumeric = isNumeric;
Number.isBetween = isBetween;
Number.random = random;
Number.range = range;
Number.serial = serial;
//# sourceMappingURL=number.js.map